import type { HelpFile } from '../../types/help'
import { ResourceDetailTestIds } from '../../../testids/ResourceDetailTestIds'

export const resourceDetailHelp: HelpFile = {
  docPage: '/docs/systems/resources',
  texts: {
    [ResourceDetailTestIds.resourceDetailPage]: 'Geschützte Ressource im Detail — Attribute, Verantwortliche, untergeordnete Ressourcen, Enforcement-Objekte und zugehörige Zugriffsprofile.',
    [ResourceDetailTestIds.cardResourceDetails]: 'Kernattribute: Name, Typ, Klassifizierung und übergeordnetes System.',
    [ResourceDetailTestIds.btnDeleteResource]: 'Diese Ressource löschen. Wird mit 409 abgelehnt, solange noch untergeordnete Ressourcen oder Enforcement Objects darauf verweisen.',
    [ResourceDetailTestIds.linkParentResource]: 'Übergeordnete Ressource in der Hierarchie öffnen.',
    [ResourceDetailTestIds.linkSystem]: 'Zielsystem öffnen, dem diese Ressource zugeordnet ist.',
    [ResourceDetailTestIds.sectionAccessProfiles]: 'Zugriffsprofile, die Zugriff auf diese Ressource gewähren.',
    [ResourceDetailTestIds.sectionAttributes]: 'Benutzerdefinierte Attribute dieser Ressource.',
    [ResourceDetailTestIds.sectionChildren]: 'In der Hierarchie untergeordnete Ressourcen.',
    [ResourceDetailTestIds.sectionEnforcementObjects]: 'Enforcement-Objekte — Konten, Gruppenmitgliedschaften — die den Zugriff auf dem Zielsystem realisieren.',
    [ResourceDetailTestIds.colChildDataClassification]: 'Datenklassifizierung der untergeordneten Ressource — öffentlich, intern oder vertraulich.',
    [ResourceDetailTestIds.colChildName]: null,
    [ResourceDetailTestIds.colChildResourceType]: 'Ressourcentyp des untergeordneten Eintrags.',
    [ResourceDetailTestIds.colEoName]: null,
    [ResourceDetailTestIds.colEoSystem]: 'Zielsystem, auf dem dieses Enforcement-Objekt liegt.',
    [ResourceDetailTestIds.colEoType]: 'Typ des Enforcement-Objekts — Konto, Gruppe oder Rolle.',
    [ResourceDetailTestIds.colProfileName]: null,
    [ResourceDetailTestIds.colProfileRisk]: 'Mit diesem Zugriffsprofil verbundenes Risiko.',
    [ResourceDetailTestIds.colProfileSource]: 'Ob das Profil direkt auf dieser Ressource definiert oder von einer übergeordneten geerbt ist.',
    [ResourceDetailTestIds.colProfileStatus]: 'Ob dieses Zugriffsprofil aktiv und derzeit vergebbar ist.',
  },
}
